import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyBmpwTqIZtfikZq6L8hcgU7VmUWbvNI4UQ",
    authDomain: "sole-15b6f.firebaseapp.com",
    projectId: "sole-15b6f",
    storageBucket: "sole-15b6f.appspot.com",
    messagingSenderId: "1066934915181",
    appId: "1:1066934915181:web:0edda90c052c57823e6f64",
    measurementId: "G-0J1TBR39SK"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth, firebaseConfig };